import { Input } from '@/components/atoms/input';

interface DataTableTextFilterFieldProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder: string;
}

export function DataTableTextFilterField({
  value,
  onValueChange,
  placeholder,
}: DataTableTextFilterFieldProps) {
  return (
    <Input
      value={value}
      onChange={(e) => onValueChange(e.target.value)}
      placeholder={placeholder}
      className="h-9 min-w-0 text-sm"
    />
  );
}
